import { LOADER_PHASES } from '../utils';
import { Icon, LinkIcon, Pane, PauseIcon, PlayIcon } from 'evergreen-ui';
import styled, { keyframes } from 'styled-components';

const glowAnimation = keyframes`
    0%{ box-shadow: 0 0 16px -18px #ffb286; }
    25%{ box-shadow: 0 0 16px -1px #ffb286; }
    100%{ box-shadow: 0 0 16px -18px #ffb286; }
`;

const StyledLoader = styled(Pane)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 1;
  color: #a7aaac;
  width: 44px;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  background: #2b2d2e;
  border-radius: 44px;
  &:hover {
    cursor: pointer;
    background: #323436;
  }
  &.reconnector {
    background: #ffa46f;
    animation: ${glowAnimation} 1s linear infinite;
    &:hover {
      cursor: pointer;
      background: #ffb286;
    }
  }
`;
const StyledLoadingAnimation = styled(Icon)`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.5s;
  opacity: 0;
  width: 10px;

  &.loading {
    opacity: 1;
    width: 28px;
  }
`;

const SearchToggle = ({ phase, onClick, isLinked }) => {
  const loading = [LOADER_PHASES.INITIATING, LOADER_PHASES.SEARCHING].includes(phase);
  return isLinked ? (
    <StyledLoader onClick={onClick}>
      <StyledLoadingAnimation
        size={28}
        color="#FFA46F"
        style={{ paddingLeft: 4 }}
        icon={PlayIcon}
        className={!loading ? 'loading' : ''}
      />
      <StyledLoadingAnimation size={26} icon={PauseIcon} className={loading ? 'loading' : ''} />
    </StyledLoader>
  ) : (
    <StyledLoader className="reconnector" onClick={onClick}>
      <Icon icon={LinkIcon} size={21} color="#FFFFFF" />
    </StyledLoader>
  );
};

export default SearchToggle;
